"use client";

import { IconCopy, IconMarkdown } from "@tabler/icons-react";
import clsx from "clsx";
import { useState } from "react";
import Button from "src/components/common/Button/Button";
import IconButton from "src/components/common/IconButton/IconButton";
import { errorToast, successToast } from "src/components/common/Toasts/ToastActions";
import { usePathname } from "src/lib/Navigation";
import { useExtracted } from "#i18n";
import styles from "./DocsMarkdownActions.module.scss";

export default function DocsMarkdownActions({ className }: { className?: string }) {
  const translateMessage = useExtracted();
  const pathname = usePathname();
  const markdownHref = pathname === "/docs" ? "/docs.md" : `${pathname}.md`;
  const [copying, setCopying] = useState(false);

  const copyMarkdown = async () => {
    setCopying(true);
    try {
      const response = await fetch(markdownHref);
      if (!response.ok) throw new Error("Markdown request failed");
      await navigator.clipboard.writeText(await response.text());
      successToast(translateMessage("Copied to clipboard"));
    } catch {
      errorToast(translateMessage("Could not copy Markdown"));
    } finally {
      setCopying(false);
    }
  };

  return (
    <fieldset
      className={clsx(styles.group, className)}
      aria-label={translateMessage("Markdown actions")}
    >
      <Button
        href={markdownHref}
        label={translateMessage("View as Markdown")}
        size="sm"
        variant="outline"
      >
        <IconMarkdown aria-hidden size={16} />
        {translateMessage("View as Markdown")}
      </Button>
      <IconButton
        label={translateMessage("Copy Markdown")}
        size="sm"
        variant="outline"
        loading={copying}
        onClick={copyMarkdown}
      >
        <IconCopy aria-hidden size={16} />
      </IconButton>
    </fieldset>
  );
}
